import { FC, useRef } from "react";
import { useUpdateEffect } from "react-use";
import { useOnScreen } from "../../hooks/useOnScreen";

type OnScreenProps = {
  rootMargin?: number;
  onAppear: (position: "above" | "below") => void;
  onDisappear: (position: "above" | "below") => void;
};

const OnScreen: FC<OnScreenProps> = (props) => {
  const ref = useRef(null);
  const [onScreen, position] = useOnScreen(ref, props.rootMargin || 0);

  useUpdateEffect(() => {
    if (!onScreen) props.onDisappear(position);
    else props.onAppear(position);
  }, [onScreen]);

  return <div ref={ref}>{props.children}</div>;
};

export default OnScreen;
